import { getPublishedSchedules } from "../controller/get-published-schedules"
import { SeedSource } from "authoring/lib/enum/seed-source.mjs"

// Overlays the current published version + published date (FiQ Schedules table source of truth)
// onto the given schedules, so list rows show what is being published over rather than draft values.
// A new schedule has nothing published to overlay, and its draft key may match an unrelated schedule.
export async function attachPublishedSourceData({ projectId, schedules }) {
    const scheduleIds = schedules
        .filter((schedule) => !isNewSchedule(schedule))
        .map((schedule) => schedule.id)
        .filter(Boolean)
    const publishedSchedules = await getPublishedSchedules({ projectId, scheduleIds })
    const publishedById = new Map((publishedSchedules ?? []).map((schedule) => [schedule.id, schedule]))
    return schedules.map((schedule) =>
        mergePublishedSourceData(schedule, isNewSchedule(schedule) ? null : publishedById.get(schedule.id))
    )
}

function isNewSchedule(schedule) {
    return schedule?.seedSource === SeedSource.NEW
}

function mergePublishedSourceData(schedule, published) {
    return {
        ...schedule,
        version: published?.version ?? null,
        metadata: { ...schedule.metadata, published: published?.metadata?.published ?? null },
    }
}
